/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formatters.ts
 🗓️ Created: 2025-01-17
 🧩 Description:
    Formatting utilities for Gateway data display.
────────────────────────────────────────────────────────────────*/

/**
 * Format date for display
 */
export function formatDate(date: string | Date): string {
  if (!date) return '—';
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  if (Number.isNaN(dateObj.getTime())) return '—';
  return dateObj.toLocaleDateString();
}

/**
 * Empty placeholder constant
 */
export const EMPTY_PLACEHOLDER = '—';

/**
 * Format boolean as Yes/No
 */
export function formatBoolean(value: boolean, t: (key: string) => string): string {
  return value ? t('common.yes') : t('common.no');
}

